import ConditionsTable from './ConditionsTable';

export default ConditionsTable;
